<div class="score_percentage" [ngClass]="{'score_card_per': pageName == 'score'}">
    <div class="container">
    <div class="row justify-content-center">
            <div class="col-md-10">
                <h2 class="text-left">CAT Score vs Percentile in 2025</h2>
                <p><span>CAT Score:</span> The total marks obtained by a candidate in the CAT exam.</p>
                <p><span>CAT Percentile:</span> The relative position of a candidate as compared to all other test takers.</p>
                <p>The final result consists of both the CAT score and percentile. Your score determines your percentile, with MBA colleges considering the percentile for admissions. Creating Score Vs Percentile data is a crucial aspect amid rising competition in CAT. Our CAT score calculator tool provides the raw score and estimated percentile. Checkout the Score vs Percentile data for CAT 2023 & 2024 below.</p>
            </div>
            <div class="col-md-10">
                <mat-tab-group mat-align-tabs="start" (selectedTabChange)="onTabChanged($event);">
                    <mat-tab label="Overall">
                        <div class="about-cat-wrapper">
                            <div class="row mx-md-0">
                                <div class="col-md-6">
                                    <canvas id="myChart" width="500" ></canvas>
                                </div>

                                <div class="col-md-6">
                                    <div class="fb_group analysis_div">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="img ">
                                                    <img
                                                        src="https://media.iquanta.in/ui_images/score-vs-percentile-small.jpeg">
                                                </div>
                                                </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </mat-tab>
                    <mat-tab label="VARC">
                        <div class="about-cat-wrapper">
                            <div class="row mx-md-0">

                                <div class="col-md-6">

                                    <canvas id="myChart1" width="500" height="300"></canvas>


                                </div>

                                <div class="col-md-6">
                                    <div class="fb_group analysis_div">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="img ">
                                                    <img
                                                        src="https://media.iquanta.in/ui_images/score-vs-percentile-small.jpeg">
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </mat-tab>
                    <mat-tab label="LRDI">
                        <div class="about-cat-wrapper">
                            <div class="row mx-md-0">

                                <div class="col-md-6">

                                    <canvas id="myChart2" width="500" height="300"></canvas>


                                </div>

                                <div class="col-md-6">
                                    <div class="fb_group analysis_div">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="img ">
                                                    <img
                                                        src="https://media.iquanta.in/ui_images/score-vs-percentile-small.jpeg">
                                                </div>
                                              
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </mat-tab>
                    <mat-tab label="Quant">
                        <div class="about-cat-wrapper">
                            <div class="row mx-md-0">

                                <div class="col-md-6">

                                    <canvas id="myChart3" width="500" height="300"></canvas>


                                </div>

                                <div class="col-md-6">
                                    <div class="fb_group analysis_div">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="img ">
                                                    <img
                                                        src="https://media.iquanta.in/ui_images/score-vs-percentile-small.jpeg">
                                                </div>
                                            
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </mat-tab>

                </mat-tab-group>

            </div>


        </div>



    </div>
</div>